
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import Layout from "../../components/common/Layout";
import Product from "../../components/product";
import OurRules from "../../components/ourRules";
import InfoSection from "../../components/infoSection";
import Instagram from "../../components/instagram";
import {GetServerSideProps} from "next";
import {useRouter} from "next/router";
import storevio from "@lib/api";
import {useUI} from "@components/ui";
import {useEffect, useState} from "react";
import cn from "classnames"
import FlashMessage from "@components/common/FlashMessages";
import useTranslation from "next-translate/useTranslation";
import Paginator from "@components/common/Paginator";
import useCustomer from "@framework/customer/use-customer";
import parseCookie from "@lib/cookieParser";
import getValueFromObject from "@lib/getValueFromObject";
import {CUSTOMER_COOKIE} from "@framework/const"; // This only needs to be imported once in your app

// import useTranslation from 'next-translate/useTranslation';

// @ts-ignore
 async function _getServerSideProps({locale, query, req}: GetServerSideProps<{name: string}>) {
    const cookies = parseCookie(req.headers.cookie);

    const sort: any = { sort: query.sort ? query.sort : 'createdAt', order: query.order ? query.order : 'DESC' };
    const filter: any = {
        priceFrom: query.priceFrom ? query.priceFrom : '',
        priceTo: query.priceTo ? query.priceTo : '',
        parameters: query.parameter ? query.parameter : [],
        variants: query.variant ? query.variant : [],
        branchOffice: query.branchOffice ? query.branchOffice : [],
        tag: query.tag ? query.tag : []
    };

    console.log(filter)

    const topNavLinks = await storevio.getMenu(locale!,'top')
    const bottomNavLinks = await storevio.getMenu(locale!,'bottom')
    const products = await storevio.getProducts(locale!, query.page, null, sort, filter, null, getValueFromObject(cookies, CUSTOMER_COOKIE));
    ;
    const settings = await storevio.getSettings(locale!);

    return {
        props: {
            topNavLinks,
            bottomNavLinks,
            products,
            settings,
        },
    }
}

export default function Category({...props}) {
    const { t } = useTranslation('common');
    const router = useRouter()
    const { openSidebar, setSidebarView, filter } = useUI()
    const [products, setProducts] = useState<any[]>()
    const [getPaginator, setPaginator] = useState<any>()
    const customer = useCustomer()

    useEffect(() => {
        setProducts(props.products.data)
        setPaginator(props.products.paginator)
    }, [router.query])


    useEffect(() => {
        router.replace(router.asPath);
    }, [customer.data])
    /*
    useEffect(() => {
        async function fetchData() {
            if(!router.query.sort && !router.query.priceFrom) return;
            const sort: any = { sort: router.query.sort ? router.query.sort : 'price', order: router.query.order ? router.query.order : 'ASC' };
            const filter: any = {
                priceFrom: router.query.priceFrom ? router.query.priceFrom : '',
                priceTo: router.query.priceTo ? router.query.priceTo : '',
                parameters: router.query.parameter ? router.query.parameter : [],
                variants: router.query.variant ? router.query.variant : [],
            };

            const products = await storevio.getProducts(router.locale!, null, sort, filter);

            // @ts-ignore
            setProducts(products.data);
        }
        fetchData();
    }, [router.query]);*/


    const handleOpenFilter = (e: any) => {
        e.preventDefault();
        setSidebarView('FILTER')
        openSidebar()
    }

    const handleSort = (e: any) => {
        e.preventDefault();
        const sort = e.target.getAttribute("data-sort");
        const order = e.target.getAttribute("data-order");
        router.query.sort = sort;
        if(sort == 'price') {
            router.query.order = order;
        } else if(sort == 'bestsellers') {
            delete router.query.order;
        }
        router.push(router);
    }

    if (router.isFallback) {
        return <h1>loading..</h1>
    }


    return (
        <>
            <div className="page-wrapper">
                <section className="products-section">
                    <div className="products-section-head">
                        <h2>
                            {t("Všechny produkty")}
                        </h2>
                        <div className="products-section-tools">
                            <a href="#" data-sort={"price"} data-order={"ASC"} onClick={handleSort} className={cn("btn", {["btn-white"]: !(router.query.order === 'ASC' && router.query.sort === 'price')})}>
                                {t("Nejlevnější")}
                            </a>
                            <a href="#" data-sort={"price"} data-order={"DESC"} onClick={handleSort} className={cn("btn", {["btn-white"]: !(router.query.order === 'DESC' && router.query.sort === 'price')})}>
                                {t("Nejdražší")}
                            </a>
                            <a href="#" data-sort={"bestsellers"} onClick={handleSort} className={cn("btn", {["btn-white"]: !(router.query.sort === 'bestsellers')})}>
                                {t("Nejprodávanější")}
                            </a>
                            <a href={"#"} onClick={handleOpenFilter} className="btn btn-filter open-sidebar">
                                {t("Filtr klobouku")}
                            </a>
                        </div>
                    </div>
                    <div className="products">
                        {products?.length == 0 &&
                            <FlashMessage
                                message={t("NotFoundProductMessage")}
                                type={"info"}/>
                        }
                        <div className="products-wrap">
                            {products?.map((product) => <Product
                                product={product}
                                key={product.id}
                                id={product.id}
                                slug={product.slug}
                                name={product.name}
                                tags={product.tags}
                                options={props.settings}
                                price={product.price}
                                hasVariants={product.hasVariants}
                                variants={product.variants}
                                image={product.mainPhoto}
                            />)}
                        </div>
                    </div>

                    {getPaginator && <Paginator
                        totalCount={getPaginator.totalCount}
                        page={getPaginator.page}
                        pageCount={getPaginator.pageCount}
                        itemsPerPage={getPaginator.itemsPerPage}
                    />}

                </section>


                <OurRules />
                <InfoSection />
                <Instagram />

            </div>
        </>
    );
}

Category.Layout = Layout


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/category/index',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  